<template>
  <div class="user">
    <!--添加任务-->
    <div class="common-seach-wrap">
      <el-form
        :inline="true"
        size="small"
        :model="formInline"
        class="demo-form-inline"
      >
        <!-- <el-form-item label="企业id">
          <el-input
            placeholder="请输入企业id"
            v-model="formInline.search"
          >
          </el-input>
        </el-form-item> -->
        <el-form-item>
          <el-button size="small" type="info" v-if="supply_id > 0" @click="cancelFunc">返回上一页</el-button>
          <el-button type="primary" icon="el-icon-search" @click="getData"
            >查询</el-button
          >
        </el-form-item>
      </el-form>
    </div>

    <div class="common-level-rail">
      <el-button
        size="small"
        icon="el-icon-plus"
        type="primary"
        @click="addClick"
        >添加详情</el-button
      >
    </div>

    <div class="product-content">
      <el-form ref="form" :model="form" label-width="100px">
        <div class="table-wrap">
          <el-table
            size="small"
            :data="tableData"
            border
            style="width: 100%"
            v-loading="loading"
          >
            <el-table-column
              prop="name"
              label="所属协会"
            ></el-table-column>
            <el-table-column prop="address" label="地址"></el-table-column>
            <el-table-column prop="phone" label="电话"></el-table-column>
            <el-table-column prop="email" label="邮箱"></el-table-column>
            <el-table-column prop="sort" label="排序"></el-table-column>
            <el-table-column
              prop="create_time"
              label="创建时间"
              width="150"
            ></el-table-column>
            <el-table-column fixed="right" label="操作" width="150">
              <template slot-scope="scope">
                <el-button
                  @click="previewClick(scope.row)"
                  type="text"
                  size="small"
                  >预览</el-button
                >
                <el-button
                  @click="editClick(scope.row)"
                  type="text"
                  size="small"
                  >编辑</el-button
                >
                <el-button
                  @click="deleteClick(scope.row)"
                  type="text"
                  size="small"
                  >删除</el-button
                >
              </template>
            </el-table-column>
          </el-table>
        </div>
      </el-form>
      <!--分页-->
      <div class="pagination">
        <el-pagination
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
          background
          :current-page="curPage"
          :page-size="pageSize"
          layout="total, prev, pager, next, jumper"
          :total="totalDataNumber"
        ></el-pagination>
      </div>
    </div>

    <Add :open_add="open_add" :role="role" :supply_id="supply_id" v-if="open_add" @close="closeAdd"></Add>
    <Edit
      :open_add="open_edit"
      :supply_detail_id="supply_detail_id"
      v-if="open_edit"
      @close="closeEdit"
      :role="role"
       :supply_id="supply_id"
    ></Edit>

    <!-- 预览弹窗 -->
    <Preview
      :open_preview="open_preview"
      :preview_data="preview_data"
      :role="role"
      v-if="open_preview"
      @close="closePreview"
    ></Preview>

    <el-dialog
      style="text-align: center"
      title="设置标题"
      :visible.sync="dialogVisible"
      @close="dialogFormVisible"
      :close-on-click-modal="false"
      :close-on-press-escape="false"
      :append-to-body="true"
    >
    </el-dialog>
  </div>
</template>

<script>
import Supply_detailApi from "@/api/supply_detail.js";
import Add from "./part/add.vue";
import Edit from "./part/edit.vue";
import Preview from "./part/preview.vue"; // 新增预览组件

export default {
  components: {
    Add,
    Edit,
    Preview
  },
  inject: ["reload"],
  data() {
    return {
      /*是否加载完成*/
      loading: true,
      /*列表数据*/
      tableData: [],
      /*一页多少条*/
      pageSize: 20,
      /*一共多少条数据*/
      totalDataNumber: 0,
      /*当前是第几页*/
      curPage: 1,
      /*搜索表单对象*/
      form: {},
      formInline: {
        search: ""
      },

      open_add: false,
      open_edit: false,
      open_preview: false, // 新增预览状态
      supply_detail_id: "",
      preview_data: {}, // 预览数据
      dialogVisible: false,
      supply_id:0,
      is_back:false,
      role:""
    };
  },
  created() {
    this.supply_id =  this.$route.query.supply_id;
    this.role =  this.$route.query.role;
    this.formInline.search = this.$route.query.supply_id;
    /*获取列表*/
    this.getTableList();
  },
  methods: {
    /*取消*/
    cancelFunc() {
      this.$router.back(-1);
    },
    dialogFormVisible() {
      this.dialogVisible = false;
    },
    setting(e) {
      //企业详情标题设置
      // this.categorya_id = e
      this.dialogVisible = true;
    },
    /*关闭添加*/
    closeAdd(e) {
      this.open_add = false;
      this.getTableList();
    },
    closeEdit(e) {
      this.open_edit = false;
      this.getTableList();
    },
    /*关闭预览*/
    closePreview(e) {
      this.open_preview = false;
    },
    getData() {
      this.getTableList();
    },
    /*选择第几页*/
    handleCurrentChange(val) {
      this.curPage = val;
      this.getTableList();
    },

    /*每页多少条*/
    handleSizeChange(val) {
      this.curPage = 1;
      this.pageSize = val;
      this.getTableList();
    },

    /*获取列表*/
    getTableList() {
      let self = this;
      let Params = this.formInline;
      Params.page = self.curPage;
      Params.list_rows = self.pageSize;
      self.loading = true;
      Supply_detailApi.list(Params, true)
        .then(data => {
          self.loading = false;
          self.tableData = data.data.list.data;
          self.totalDataNumber = data.data.list.total;
        })
        .catch(error => {});
    },

    /*搜索查询*/
    onSubmit() {
      this.curPage = 1;
      this.getTableList();
    },

    /*添加任务*/
    addClick() {
      this.open_add = true;
    },

    /*预览*/
    previewClick(row) {
      this.preview_data = row;
      this.open_preview = true;
    },

    /*编辑活动*/
    editClick(row) {
      this.supply_detail_id = row.supply_detail_id;
      this.open_edit = true;
    },

    /*删除*/
    deleteClick(row) {
      let self = this;
      self
        .$confirm("此操作将永久删除该记录, 是否继续?", "提示", {
          confirmButtonText: "确定",
          cancelButtonText: "取消",
          type: "warning"
        })
        .then(() => {
          Supply_detailApi.del(
            {
              supply_detail_id: row.supply_detail_id
            },
            true
          )
            .then(data => {
              if (data.code == 1) {
                self.$message({
                  message: "删除成功",
                  type: "success"
                });
                this.getTableList();
              } else {
                self.$message.error("错了哦，这是一条错误消息");
              }
            })
            .catch(error => {});
        })
        .catch(() => {});
    }
  }
};
</script>

<style></style>


// WEBPACK FOOTER //
// src/views/plus/supply/detail/index.vue